/** Window event raised when an on-call presence incident opens, escalates, resolves or expires (BL-043 BE-088). */
export const ONCALL_PRESENCE_CHANGED_EVENT = 'nog:oncall-presence:changed';

/** Presence polling cadence used as a fallback alongside the SignalR event (BL-043 UI-060). */
export const PRESENCE_POLL_MS = 60_000;
